export type FirestoreReadEvent = {
  source: 'getDocs' | 'getDocsFromServer' | 'onSnapshot';
  collectionPath: string;
  docCount: number;
  fromCache?: boolean;
  status?: 'success' | 'error';
  metadata?: Record<string, unknown>;
};

type FirestoreTelemetryListener = (event: FirestoreReadEvent) => void;

const listeners = new Set<FirestoreTelemetryListener>();

export const recordFirestoreRead = (event: FirestoreReadEvent) => {
  listeners.forEach((listener) => {
    try {
      listener(event);
    } catch (error) {
      // Swallow listener errors so telemetry never blocks read operations.
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('[firestoreTelemetry] Listener failed', error);
      }
    }
  });
};

export const subscribeToFirestoreTelemetry = (
  listener: FirestoreTelemetryListener,
): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const __testing = {
  reset: () => {
    listeners.clear();
  },
};


